import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CustomModal, InfoBanner, SpinnerLoader } from "@services/ui-components";
import { cloneNameToDisplay } from "../../../utils/cloneNameUtils";

interface ConfirmReplaceMenuModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    menuTypeName?: string;
    menuName?: string;
    loading?: boolean;
}

const ConfirmReplaceMenuModal: React.FC<ConfirmReplaceMenuModalProps> = ({
    show,
    onClose,
    onConfirm,
    menuTypeName,
    menuName,
    loading,
}) => {
    const { t } = useTranslation();

    return (
        <CustomModal
            show={show}
            handleClose={onClose}
            title={
                <Container>
                    <Row>
                        <h5 className="m-0 p-0 fw-normal">{t("Replace the published menu?")}</h5>
                    </Row>
                </Container>
            }
            body={
                <Container>
                    <Row>
                        <Col>
                            <p className="fs-16 text-dark mb-3">
                                {t(
                                    "Once published, this menu will open via the {{menuTypeName}} menu QR code, replacing the current menu {{menuName}}.",
                                    {
                                        menuTypeName,
                                        menuName: cloneNameToDisplay(menuName, t),
                                    }
                                )}
                            </p>
                            <InfoBanner marginClasses="mb-0">
                                <p className="text-primary mb-0">
                                    {t("The QR code will remain the same — no replacement is needed.")}
                                </p>
                            </InfoBanner>
                        </Col>
                    </Row>
                </Container>
            }
            buttons={[
                {
                    text: t("Cancel"),
                    onClick: onClose,
                    variant: "outline-primary",
                    className: "w-100 fw-normal",
                },
                {
                    text: loading ? <SpinnerLoader variant="light" loadingText={t("Loading...")} /> : t("Publish"),
                    onClick: onConfirm,
                    variant: "primary",
                    className: "w-100 fw-bold",
                    disabled: loading,
                },
            ]}
        />
    );
};

export default ConfirmReplaceMenuModal;
